const redactTokenParam = (url: string) => url.replace(/token=[^&#]+/g, 'token=[redacted]')

export const scrubTokenFromUrl = (url: string | undefined): string | undefined => {
    if (!url?.includes('token=')) return url
    try {
        const parsed = new URL(url)
        if (!parsed.searchParams.has('token')) return redactTokenParam(url)
        parsed.searchParams.set('token', '[redacted]')
        return parsed.toString()
    } catch {
        return redactTokenParam(url)
    }
}

const removeNonceParam = (url: string) => url.replace(/nonce=[^&#]*&?/g, '').replace(/[?&]$/, '')

export const stripNonceFromUrl = (url: string): string => {
    if (!url.includes('nonce=')) return url
    try {
        const parsed = new URL(url)
        if (!parsed.searchParams.has('nonce')) return removeNonceParam(url)
        parsed.searchParams.delete('nonce')
        return parsed.toString()
    } catch {
        return removeNonceParam(url)
    }
}
